import * as React from "react";
const SvgHandle = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}><path fill="#000" d="M2 8h20v2.5H2zm0 5h20v2.5H2z" /></svg>;
export { SvgHandle as ReactComponent };